/**
 * Button — Action button used inside exam cards, modals, and forms.
 *
 * Restyled to the 5mi.uz warm pastel design:
 *   - primary    solid coral                    ("Boshlash", form submit)
 *   - ghost      outline surface                (secondary)
 *   - green      solid mint                     (positive — "Natija")
 *   - gold       solid butter                   (highlight — "Reyting")
 *   - disabled   muted                          (not clickable)
 *
 * Modifier `block` makes it full-width.
 */
import { forwardRef } from 'react'

const BASE =
  'inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-full ' +
  'text-sm font-semibold whitespace-nowrap transition-all cursor-pointer ' +
  'outline-none border hover:-translate-y-0.5'

const VARIANT_STYLE = {
  primary: {
    background: 'var(--coral)', borderColor: 'transparent', color: '#fff',
    boxShadow: '0 6px 16px rgba(255,122,82,.35)',
  },
  ghost: { background: 'var(--surface)', borderColor: 'var(--border)', color: 'var(--ink)' },
  green: {
    background: 'var(--mint)', borderColor: 'transparent', color: '#fff',
    boxShadow: '0 6px 16px rgba(79,182,154,.3)',
  },
  gold: {
    background: 'var(--butter)', borderColor: 'transparent', color: '#fff',
    boxShadow: '0 6px 16px rgba(231,181,61,.3)',
  },
  disabled: { background: 'var(--bg-soft)', borderColor: 'var(--border)', color: 'var(--muted)', cursor: 'not-allowed', boxShadow: 'none' },
}

const Button = forwardRef(function Button(
  { variant = 'primary', block = false, className = '', style, children, disabled, ...props },
  ref,
) {
  const effective = disabled ? 'disabled' : variant
  return (
    <button
      ref={ref}
      disabled={disabled}
      className={`${BASE} ${block ? 'w-full' : ''} ${className}`}
      style={{ ...(VARIANT_STYLE[effective] ?? VARIANT_STYLE.primary), ...style }}
      {...props}
    >
      {children}
    </button>
  )
})

export default Button
